import { useSelector } from 'react-redux';

import { Button, CopyToClipboard, Icon, Modal } from '@components/index';

interface ShareOption {
  id: string;
  name: string;
  icon: string;
  action: () => void;
}

interface ShareModalProps {
  isOpen: boolean;
  handleShareModalCancel: () => void;
  title?: string;
  message: string;
}

const ShareModal = ({
  isOpen,
  handleShareModalCancel,
  title,
  message
}: ShareModalProps) => {
  const { currentOrg } = useSelector((state: any) => state.user);

  const handleWhatsAppShare = () => {
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleGmailShare = () => {
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&su=${encodeURIComponent(
      `${currentOrg?.name || ''} - ${title || ''}`
    )}&body=${encodeURIComponent(message)}`;
    window.open(gmailUrl, '_blank');
  };

  const shareOptions: ShareOption[] = [
    {
      id: 'whatsapp',
      name: 'Whatsapp',
      icon: 'whatsapp-icon',
      action: handleWhatsAppShare
    },
    {
      id: 'gmail',
      name: 'Gmail',
      icon: 'mail-icon',
      action: handleGmailShare
    }
  ];

  return (
    <Modal
      isOpen={isOpen}
      onCancel={() => {
        handleShareModalCancel();
      }}
      className="w-139 !rounded-2xl"
      isCloseIconRequired
      isClickOutsideRequired={false}
    >
      <div className="flex flex-col !rounded-2xl bg-white p-6">
        <div className="mb-6 flex items-center justify-between border-b border-gray-200 pb-4">
          <h2 className="text-xl font-medium text-content">Share</h2>
        </div>

        <div className="mb-4 flex items-center justify-center">
          <div className="flex w-full items-center gap-2.5 rounded-lg bg-[#FCFCFC] p-4">
            <Icon name="share-menu" size="36" />
            <div className="flex-1">
              <div className="line-clamp-2 text-sm text-grey">{message}</div>
            </div>
            <CopyToClipboard
              textToCopy={message}
              textStyle="!text-xs !text-grey !ml-1"
              className="ml-auto items-center"
              iconColor="text-cofeeNeutral8"
              text="Copy"
              tooltipClassName="!top-[-40px] !px-2.5 !py-1.5"
            />
          </div>
        </div>

        <div className="border-t border-gray-200">
          <div className="flex justify-start gap-4.5 pt-2">
            {shareOptions.map((option) => (
              <Button
                key={option.id}
                variant="transparent"
                handleClick={option.action}
                className="flex h-auto flex-col items-center rounded-lg !p-0 hover:bg-gray-50"
              >
                <div className="flex size-16 items-center justify-center rounded-2xl">
                  <Icon name={option.icon} size="48" className="size-16" />
                </div>
                <span className="text-sm font-medium text-darkGrey">
                  {option.name}
                </span>
              </Button>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ShareModal;
